import React, { useRef, useState } from "react";
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { Box, Button, Card, CssBaseline, FormControl, FormLabel, Paper, TextField, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router";
import Logo from '../images/logo.png'
import './style.css'
import OTPInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";
import { maskNumber } from "../helpers/formatter";
import { validateOtp } from "../actions/authAction";


const OTP = (props) => {
  const auth = useSelector(state => state.Auth);
  const [isOtpVerified, setOtpVerified] = useState(false);
  const [otp, setOtp] = useState('');
  const otpRef = useRef()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const handleOtp = async () => {
    const status = await dispatch(validateOtp({otp}))
    if(status){
      navigate('/dashboard')
    }
  }
  return (

    <div className="otpCoverImg">
      <Paper elevation={3} m={2} p={5} style={{}}>
        <Box className="css-rjh0ej" variant="outlined">
          <div className="brand-logo pb-4 text-center">
            <Link to={process.env.PUBLIC_URL + "/"} className="logo-link">
              <img style={{ height: 116, width: 220 }} className="logo-light logo-img logo-img-lg" src={Logo} alt="logo" />
              {/* <img className="logo-dark logo-img logo-img-lg" src={LogoDark} alt="logo-dark" /> */}
            </Link>
          </div>
          <Typography mt={2}
            component="h1"
            variant="h4"
            sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
          >
            OTP
          </Typography>
          <Typography mt={2} mb={4}>{`Enter  6 digit verification Code. Sent your mobile number ${maskNumber(auth.mobileNumber)} `}</Typography>
          <Box
            noValidate
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              gap: 2,
            }}
          >
            <FormControl >
              <FormLabel htmlFor="email">OTP</FormLabel>
              <div style={{ textAlign: 'center' }}>
                <OTPInput
                  onChange={(code) => {
                    setOtp(code);
                  }}
                  // ref={otpRef}
                  inputType={'tel'}
                  value={otp}
                  shouldAutoFocus={true}
                  isInputNum={true}
                  numInputs={6}
                  containerStyle={{
                    flex: 1,
                    justifyContent: 'center'
                  }}
                  inputStyle={"otpInputField"}
                  renderInput={(props) => <input ref={otpRef} {...props} />}
                />
              </div>
            </FormControl>

            <Button style={{ marginTop: '12px', backgroundColor: '#4DA235' }}
              type="submit"
              fullWidth
              variant="contained"
              onClick={() => { handleOtp() }}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </Paper>
    </div>


  )
}

export default OTP;